import { settings } from '@/config/settings';
import type { InputState } from '@/input/types';

/** Movement input → world vector, per the settings movement mode. */
export function resolveMove(input: InputState, facing: number): { mx: number; my: number } {
  if (settings.movementMode === 'world') {
    return { mx: input.moveX, my: input.moveY };
  }
  // 'nose': forward (up input) = facing direction; sides strafe
  const fwd = -input.moveY;
  const strafe = input.moveX;
  const cosF = Math.cos(facing);
  const sinF = Math.sin(facing);
  return {
    mx: cosF * fwd - sinF * strafe,
    my: sinF * fwd + cosF * strafe,
  };
}

/** Shortest-arc angle interpolation (ship turning). */
export function lerpAngle(from: number, to: number, t: number): number {
  let diff = to - from;
  while (diff > Math.PI) diff -= Math.PI * 2;
  while (diff < -Math.PI) diff += Math.PI * 2;
  return from + diff * t;
}
